import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const seoSettingsAdminAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.SeoMarketplaceView],
}
